import React, { useState } from "react";
import Chatbot from "./Chatbot";

const ChatbotWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div style={styles.widgetContainer}>
      {/* Label badge (only show when closed) */}
      {!open && <div style={styles.badge}>Let’s Chat!</div>}

      {/* Floating Button */}
      <button
        style={{
          ...styles.fab,
          background: open
            ? "linear-gradient(135deg,#ff5f6d,#ffc371)"
            : "linear-gradient(135deg,#ff5f6d,#ffc371)",
        }}
        onClick={() => setOpen(!open)}
      >
        {open ? "✖" : "💬"}
      </button>

      {/* Chat Window */}
      {open && (
        <div style={styles.chatWindow}>
          <Chatbot />
        </div>
      )}
    </div>
  );
};

const styles = {
  widgetContainer: {
    position: "fixed",
    bottom: "50px",
    right: "24px",
    zIndex: 1000,
  },
  fab: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    border: "none",
    color: "#fff",
    fontSize: "28px",
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    transition: "transform 0.25s ease, background 0.3s ease",
  },
  badge: {
    position: "absolute",
    bottom: "70px",
    right: "0",
    background: "var(--primary-color)",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "15px",
    fontWeight: "600",
    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
    animation: "floatUp 0.4s ease forwards",
    whiteSpace: "nowrap",
  },
  chatWindow: {
    position: "absolute",
    bottom: "80px",
    right: "0",
    width: "400px",
    height: "600px",
    background: "#fff",
    border: "1px solid #ccc",
    borderRadius: "14px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
    overflow: "hidden",
  },
};

// Optional keyframes for smooth badge float (add in a CSS file or a <style> tag)
/*
@keyframes floatUp {
  from {opacity:0; transform:translateY(10px);}
  to   {opacity:1; transform:translateY(0);}
}
*/

export default ChatbotWidget;
